import * as Sentry from "@sentry/svelte"

import "./app.css"

import { mount } from "svelte"
import App from "./App.svelte"
import { initLaunchDarkly } from "./lib/launch-darkly"
import { installContextMenuViewportFitter } from "./lib/utils/contextMenuPositioning"

if (["production", "staging"].includes(import.meta.env.MODE)) {
  Sentry.init({
    dsn: "https://e7005fc9e446d11c53c6a75483532621@o8877.ingest.us.sentry.io/4507419376943105",
    environment: import.meta.env.MODE,
    integrations: [],
  })
}

void initLaunchDarkly()

installContextMenuViewportFitter()

const app = mount(App, {
  target: document.getElementById("app")!,
})

export default app
